import Icon from '../components/Icon.vue'

Icon.register({"id-card-alt":{"width":576,"height":512,"paths":[{"d":"M512 64H384V160H192V64H64C28.7 64 0 92.7 0 128V448C0 483.3 28.7 512 64 512H160V501.3C160 454.2 198.2 416 245.3 416H330.6C377.7 416 415.9 454.2 415.9 501.3V512H511.9C547.2 512 575.9 483.3 575.9 448V128C576 92.7 547.3 64 512 64zM288 384C243.8 384 208 348.2 208 304S243.8 224 288 224 368 259.8 368 304 332.2 384 288 384zM352 32C352 14.3 337.7 0 320 0H256C238.3 0 224 14.3 224 32V128H352V32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/id-card-alt.js
// module id = null
// module chunks = 